import { IndustryLResponse } from '@doda/api-client/aspida/@types';

/**
 * 業種データ
 */
export interface IndustryData {
  /** ID */
  id: string;
  /** 業種名 */
  name: string;
  /** 業種小分類データ */
  industrySList: IndustrySData[];
  /** 選択されているかどうかのフラグ */
  isChecked: boolean;
  /** チェックボックス表示のフラグ */
  isDisplay: boolean;
}

/**
 * 業種小分類データ
 */
export interface IndustrySData {
  /** ID */
  id: string;
  /** 業種名 */
  name: string;
  /** 選択されているかどうかのフラグ */
  isChecked: boolean;
  /** チェックボックス表示のフラグ */
  isDisplay: boolean;
  /** 親の業種ID */
  parentId: string;
}

/**
 * 業種大分類の配列を生成
 * @param masterData 業種マスタ
 * @param sIdList 業種小分類IDの配列
 * @param industrySList 業種小分類データ
 * @returns 業種大分類データ
 */
export const createIndustryLargeData = (
  masterData: IndustryLResponse[],
  sIdList: string[] | undefined,
  industrySList: IndustrySData[]
): Omit<IndustryData, 'industrySList'>[] => {
  const sParentIdList = [
    ...new Set(industrySList.map((industryS) => industryS.parentId)),
  ];

  return masterData.flatMap(({ id, name }) => {
    const isDisplayValue = sIdList?.includes(id) ?? false;

    return isDisplayValue || sParentIdList.includes(id)
      ? [
          {
            id,
            name,
            isChecked: isDisplayValue,
            isDisplay: isDisplayValue,
          },
        ]
      : [];
  });
};

/**
 * 業種小分類の配列を生成
 * @param masterData 業種マスタ
 * @param sIdList 業種小分類データ
 * @returns 業種小分類データ
 */
export const createIndustrySmallData = (
  masterData: IndustryLResponse[],
  sIdList: string[] | undefined
): IndustrySData[] => {
  return masterData.flatMap((industryL) =>
    industryL.industrySList.flatMap(({ id, name }) => {
      const isDisplayValue = sIdList?.includes(id) ?? false;

      return isDisplayValue
        ? [
            {
              id,
              name,
              isChecked: true,
              isDisplay: true,
              parentId: industryL.id,
            },
          ]
        : [];
    })
  );
};

/**
 * 表示用配列の生成処理
 * @param industryLList 業種大分類データ
 * @param industrySList 業種小分類データ
 * @returns 業種データ
 */
export const createIndustryDisplayList = (
  industryLList: Omit<IndustryData, 'industrySList'>[],
  industrySList: IndustrySData[]
): IndustryData[] => {
  return industryLList.map((industryL) => ({
    ...industryL,
    industrySList: industrySList.filter(
      ({ parentId }) => parentId === industryL.id
    ),
  }));
};
